<!--
 * @Author: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @Date: 2025-02-11 14:57:33
 * @LastEditors: guoxioaoxiao guoxiaoxiao01@longfor.com
 * @LastEditTime: 2025-03-14 10:25:25
 * @FilePath: /qd-c4-yunjing-web/src/layouts/components/logo/index.vue
 * @Description: 侧边导航
-->
<template>
  <section class="logo-container">
    <router-link
      to="/"
      class="logo-content"
    >
      <img
        :src="logoSrc"
        class="sidebar-logo"
      />
    </router-link>
  </section>
</template>
<script lang="ts" setup="logo">
  import { computed } from 'vue';
  import { useTenantStore } from '@/store/tenant';

  const {
    VITE_APP_LOGO_DIR: defaultLogo,
  } = import.meta.env;

  const tenantStore = useTenantStore();

  // 优先使用租户配置的 logo，否则使用默认 logo
  const logoSrc = computed(() => {
    const currentTenant = tenantStore.currentTenant;
    if (currentTenant?.expandInfo) {
      let expandInfo = currentTenant.expandInfo;
      if (typeof expandInfo === 'string') {
        try {
          expandInfo = JSON.parse(expandInfo);
        } catch {
          // 解析失败使用默认值
        }
      }
      if ((expandInfo as any)?.tenantLogo) {
        return (expandInfo as any).tenantLogo;
      }
    }
    return defaultLogo;
  });
</script>

<style lang="scss" scoped>
  .logo-container {
    display: flex;
    flex: none;
    align-items: center;
    height: var(--maia-nav-header-height);

    .logo-content {
      display: flex;
      align-items: center;
      justify-content: center;

      .sidebar-logo {
        height: 40px;
        width: auto;
        object-fit: contain;
      }
    }
  }
</style>
